<template>
  <div class="w-full grid grid-flow-col grid-cols-13 gap-x-6 items-center py-6">
    <Input
      v-model="search"
      placeholder="Search by keywords"
      class="col-start-1 col-end-2"
    />
    <Input
      v-model="post_id"
      placeholder="Search by Post Id"
      class="col-start-2 col-end-4"
    />
    <Select
      v-model="industry"
      placeholder="Industry"
      class="col-start-4 col-end-6"
      :options="industries"
    />

    <Select
      v-model="is_ad"
      placeholder="Ads/Organic"
      class="col-start-6 col-end-7"
      :options="[
        { label: 'Ads', value: 'Ads' },
        { label: 'Organic Videos', value: 'Organic Videos' },
        { label: 'All', value: 'All' },
      ]"
    />

    <div class="col-start-1 col-end-14 pt-4 flex text-base">
      <template
        v-for="(value, name) in {
          industry,
          is_ad,
        }"
        :key="`filter${value}`"
      >
        <span
          class="filters__item"
          v-if="value"
          @click="removeFilterOption(name)"
        >
          <Icon name="Check" class="check w-4 h-4 mr-2" />
          <Icon name="Close" class="close w-4 h-4 mr-2" />
          {{ value }}
        </span>
      </template>
      <span
        class="filters__item"
        @click="resetFilters"
        v-if="industry || type || objective || format"
      >
        <Icon name="Refresh" class="refresh w-4 h-4 mr-2" />Reset All
      </span>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";
import Select from "@/components/UI/Select/index";
import Icon from "@/components/UI/Icon";

export default {
  components: { Input, Select, Icon },
  setup() {
    const store = useStore();

    const search = ref("");
    const post_id = ref("");
    const industry = ref("");
    const is_ad = ref("");

    const industries = computed(() => store.state.industries);

    watch(
      [search, post_id],
      debounce(() => {
        getTiktoks();
      }, 1500)
    );

    watch([industry, is_ad], () => {
      if (industry.value || is_ad.value) getTiktoks();
    });

    const getTiktoks = () => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_TIKTOKS", null);
      store.dispatch("GET_TIKTOKS", {
        search: search.value ? search.value : undefined,
        industry: industry.value ? industry.value : undefined,
        is_ad: is_ad.value ? is_ad.value : undefined,
        post_id: post_id.value ? post_id.value : undefined,
      });
    };

    const resetFilters = () => {
      search.value = null;
      industry.value = null;
      is_ad.value = null;
      post_id.value = null;

      store.commit("SET_FILTERS", {});
      store.commit("SET_PAGE", 0);
      store.commit("SET_TIKTOKS", null);
      store.dispatch("GET_TIKTOKS");
    };

    const removeFilterOption = (name) => {
      switch (name) {
        case "industry":
          industry.value = null;
          break;
        case "is_ad":
          is_ad.value = null;
          break;
        default:
          break;
      }
    };

    return {
      search,
      industry,
      is_ad,
      post_id,
      industries,
      getTiktoks,
      resetFilters,
      removeFilterOption,
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}
.filters__item svg {
  transition: 0.3s;
}
.filters__item:hover .check,
.filters__item .close {
  display: none;
}
.filters__item:hover .close {
  display: block;
}
.filters__item:hover .refresh {
  transform: rotate(60deg);
}
</style>
